import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import isBrowser from 'utils/isBrowser'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { searchParameters, globalData } from 'tracking/dataCollectors'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      objectId: 'search',
      objectName: 'Search box',
      event: 'view',
      eventType: 'View', // Begin with uppercase
      objectType: 'Listing', // Begin with uppercase
      domain: 'adout', // Technical domain. Ex. Adout
      subDomain: 'list',
      origin: {
        id: `search`,
        type: 'Listing',
        url: encodeURI(window.location.href),
      },
    },
    ...searchParameters(
      _.get(state, 'searchParams'),
      _.get(state, 'classified.searchResults.query'),
    ),
    ...localData,
  })
export const viewSearchDefault = {
  validators: [
    validators.redux(
      '@@router/LOCATION_CHANGE',
      (action) => _.get(action, 'payload.location.pathname', '').startsWith('/sok') && isBrowser(),
    ),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}))],
}
